const fontWeights = {
  normal: '400',
  regular: 'normal',
  semiBold: '600',
  bold: '700',
}

export default fontWeights
